/**
 * Configuración del modulo ACL (Access Control Level)
 */
const config = {
  actions: {
    create: "crear",
    update: "modificar",
    print: "imprimir",
    confirm: "confirmar",
    delete: "eliminar",
    show: "ver",
    cancel: "cancelar",
    export: "exportar",
    createDrafts: "crearBorradores",
    restartTask: "restartTask",
  },
  targets: {
    // MENU CONTENEDORES
    acl: "menu_permisos",
    maestros: "menu_maestros",
    reportes: "menuReportes",
    menu_configuracion: "menu_configuracion",
    procesos: "procesos",
    integraciones: "integraciones",
    reprocesos: "reprocesos",
    integracion_pos: "integracion_pos",
    sincronizar_resoluciones: "sincronizar_resoluciones",
    app: "app",

    // ACL
    objetos: "acl_objetos",
    acciones: "acl_acciones",
    usuarios: "acl_usuarios",
    roles: "acl_roles",
    reglas: "acl_reglas",
    entidades: "acl_entidades",
    // WORKFLOW
    casos: "wf_casos",
    borradores: "borradores",
    tareas: "wf_tareas",
    menu_tareas: "menutareas",
    admin_tasks: "admintasks",
    equipos: "wf_equipos",
    protocolos: "wf_protocolos",
    asignaciones: "wf_equipos_integrantes",
    participantes: "wf_casos_participantes",
    // MAESTROS
    definiciones: "definiciones",
    departamentos: "departamentos",
    municipios: "municipios",
    formularios: "formularios",
    funciones: "funciones",
    //Editor de plantillas
    plantilla_correo: "plantillas_editor",
    plantilla_pdf: "plantillas_editor_pdf",
    plantilla_inicio: "plantillas_editor_inicio",
    plantillas_formularios: "plantillas_formularios",
    preliquidacion: "preliquidacion",
    contratos: "contratos",
    depreciacion: "depreciacion",
    reports: "report",
    reports_v2: "report",
    new_template: "new_template",
    //Reenviar correos
    reenviar_correos: "reenviarcorreos",
    // citas
    citas: "citas",
    actividades: "actividades",
    crear_turnos: "crearTurnos",
    ver_turnos: "verTurnos",
    //Componentes:
    importarDatos: "importarDatos",
    wf_abrir_casos: "wfabrircasos",
  },
  roles: {
    "super-admin": { label: "Soporte", label_en: "S", id: "super-admin" },
    invitado: { label: "invitado" },
  },
};

export default config;
